import lapdev from '../../lapdev';

export function getUserInvitation(code) {
  return lapdev.get(`users/invitations/${code}`);
}
